package com.essntl.features.itinerary.ui.edit_itinerary

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.task.domain.model.TaskModel
import kotlinx.datetime.LocalDate

sealed interface EditItineraryEvent {

    /**
     * Itinerary service events
     */
    data object GetAllItinerary : EditItineraryEvent

    data class GetItinerary(val id: String) : EditItineraryEvent

    data class EditItinerary(val proposal: ProposalModel) : EditItineraryEvent

    data object ClearItinerary : EditItineraryEvent

    data object ClearItineraryState : EditItineraryEvent

    data object GetAllItineraryService : EditItineraryEvent

    data class GetAllItineraryServiceByDate(
        val date: LocalDate,
    ) : EditItineraryEvent

    data class GetAllItineraryServiceByDateRange(
        val startDate: String?,
        val endDate: String?,
    ) : EditItineraryEvent

    data class AddItineraryService(
        val itinerary: ItineraryModel,
        val service: ServiceModel,
    ) : EditItineraryEvent

    data object ClearItineraryService : EditItineraryEvent

    data class SelectItineraryService(
        val itineraryServiceId: String,
    ) : EditItineraryEvent

    data object SelectAllItineraryService : EditItineraryEvent

    data class ClickItineraryService(
        val itineraryServiceId: String?,
    ) : EditItineraryEvent

    data class UpdateItineraryServiceStatus(
        val itineraryService: ItineraryServiceModel,
        val status: ItineraryServiceModel.Status,
    ) : EditItineraryEvent

    data class UpdateSelectedItineraryServiceStatus(
        val status: ItineraryServiceModel.Status,
    ) : EditItineraryEvent

    data class UpdateItineraryService(
        val itineraryService: ItineraryServiceModel,
    ) : EditItineraryEvent

    data class FilterItineraryServices(val filterOptions: ItineraryServiceFilterOptions) : EditItineraryEvent

    /**
     * Client events
     */

    data class AddClient(
        val client: ClientModel,
    ) : EditItineraryEvent

    data class EditClient(
        val client: ClientModel,
    ) : EditItineraryEvent

    data class DeleteClient(
        val client: ClientModel,
    ) : EditItineraryEvent

    data class SetPrimaryClient(
        val client: ClientModel,
    ) : EditItineraryEvent

    data class UpdateClientDetails(
        val guestDetails: String,
    ) : EditItineraryEvent

    /**
     * Task events
     */

    data class DeleteTask(
        val task: TaskModel,
    ) : EditItineraryEvent

    data class EditTaskStatus(
        val taskId: String,
        val status: TaskModel.Status,
    ) : EditItineraryEvent

    /**
     * Message events
     */

    data class SendToAxus(
        val itinerary: ItineraryModel,
    ) : EditItineraryEvent

    data object GetItineraryServicesMessages : EditItineraryEvent

    /**
     * travel agent events
     */
    data object ClearTravelAgentState : EditItineraryEvent


    /**
     * proposal events
     */
    data class UpdateProposal(val proposal: ProposalModel) : EditItineraryEvent
    data object ClearProposalState : EditItineraryEvent
}